import React, { useEffect, useState } from 'react';

import CollectionsBookmarkRounded from '@mui/icons-material/CollectionsBookmarkRounded';
import LibraryAddRounded from '@mui/icons-material/LibraryAddCheckRounded';
import LibraryBooksRounded from '@mui/icons-material/LibraryBooksRounded';
import VideoLibraryRounded from '@mui/icons-material/VideoLibraryRounded';
import { Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router';

import ContentWrapper from '../../components/ContentWrapper';
import SkeletonStack from '../../components/SkeletonStack';
import Tabs from '../../components/Tabs';
import { SubjectDetails, SUBJECTS } from '../../utils/common/constants';

import CoursesSection from './CoursesSection';
import { MenuButton } from './index.styles';
import TopicsSection from './TopicsSection';

const subjects = Object.values(SUBJECTS);

const AdminSubjectsPage = () => {
  const navigate = useNavigate();
  const { subject: querySubject } = useParams();

  const [subject, setSubject] = useState<SubjectDetails | undefined>(undefined);

  useEffect(() => {
    if (querySubject) {
      const subjectObj = SUBJECTS?.[querySubject];
      if (subjectObj) {
        setSubject(subjectObj);
      }
    } else {
      setSubject(SUBJECTS[Object.keys(SUBJECTS)[0]]);
    }
  }, [querySubject]);

  if (subject === undefined) {
    return (
      <SkeletonStack />
    );
  }

  return (
    <>
      <Tabs
        options={subjects}
        selectedKey={subject.key}
        onChange={(key) => navigate(`/admin/subjects/${key}`, { replace: true })}
      />
      <ContentWrapper title="Content">
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <MenuButton
              variant="contained"
              startIcon={<CollectionsBookmarkRounded />}
              href={`/admin/notes/${subject.key}`}
            >
              Notes
            </MenuButton>
          </Grid>
          <Grid item xs={6} sm={3}>
            <MenuButton
              variant="contained"
              startIcon={<VideoLibraryRounded />}
              href={`/admin/videos/${subject.key}`}
            >
              Videos
            </MenuButton>
          </Grid>
          <Grid item xs={6} sm={3}>
            <MenuButton
              variant="contained"
              startIcon={<LibraryBooksRounded />}
              href={`/admin/resources/${subject.key}`}
              disabled
            >
              Resources
            </MenuButton>
          </Grid>
          <Grid item xs={6} sm={3}>
            <MenuButton
              variant="contained"
              startIcon={<LibraryAddRounded />}
              href={`/admin/exams/${subject.key}`}
            >
              Exams
            </MenuButton>
          </Grid>
        </Grid>
      </ContentWrapper>
      <ContentWrapper title="Courses">
        <CoursesSection subject={subject.key} />
      </ContentWrapper>
      <ContentWrapper title="Topics Groups">
        <TopicsSection subject={subject.key} />
      </ContentWrapper>
    </>
  );
};
export default AdminSubjectsPage;
